import { useEffect, useRef } from "react";
import { browserWorkspace } from "../lib/workspace";
import { connectRealtimeRoom, type RealtimeRefresh, type RealtimeEvent } from "../lib/realtimeConnection";

export function useRealtimeRoom(roomName: string, onRoomEvent: RealtimeRefresh, onEvent?: (event: RealtimeEvent) => void) {
  const callback = useRef(onRoomEvent);
  callback.current = onRoomEvent;
  const eventCallback = useRef(onEvent);
  eventCallback.current = onEvent;

  useEffect(() => {
    if (!roomName) return;
    const workspace = browserWorkspace();
    const protocol = window.location.protocol === "https:" ? "wss:" : "ws:";
    const room = encodeURIComponent(roomName);
    return connectRealtimeRoom(
      `${protocol}//${window.location.host}/api/v1/realtime/${room}?workspace=${workspace}`,
      () => callback.current(),
      roomName.startsWith("ticket:") ? 30_000 : 0,
      (event) => eventCallback.current?.(event),
    );
  }, [roomName]);
}

export function useTicketRealtime(ticketId: string, onTicketEvent: RealtimeRefresh, onEvent?: (event: RealtimeEvent) => void) {
  useRealtimeRoom(ticketId ? `ticket:${ticketId}` : "", onTicketEvent, onEvent);
}
